import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

// import store from '@/state/store'
import routes from './routes'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition || to.query.id || to.name === 'dadban-edit-discount' || to.name === 'dadban-add-discount') {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

export default router
